<template>
  <main class="sidekick-search">
    <b-container class="search">
      <b-row>
        <b-col md="4" class="search__logo d-none d-md-block">
          <img src="@/assets/logo/flowscore-white.png" alt="snkrhud white logo" class="img-fluid" />
        </b-col>
        <b-col md="8" class="search__input d-flex align-items-center">
          <b-form-input
            id="search"
            type="search"
            placeholder="Enter NFT ID"
            autofocus
            required
            v-model="snkrhdnftName"
            @keyup.enter="searchSnkrhd(snkrhdnftName)"
          />
        </b-col>
      </b-row>
    </b-container>
    <b-container
      fluid
      class="details"
      :class="{ 'd-block': found == 'yes', 'd-none': found != 'yes' }"
    >
      <b-row v-if="found == 'yes'">
        <b-col class="details__col details__col--code">
          <h2 class="details__code d-md-none">{{ nftData["Revealed Name"] }}</h2>
          <b-img fluid class="details__image" v-if="main_nft" :key="main_nft" :src="main_nft" />
        </b-col>
        <b-col class="details__col details__col--numbers">
          <div class="details__numbers d-flex">
            <div class="details__code details__code--blox d-none d-md-flex">
              <div class="resize-text-wrapper">
                <h2 v-resize-text="{ ratio: 0.32, delay: 0 }">
                  {{ nftData["Revealed Name"].slice(0, 5) }}<br />{{
                    nftData["Revealed Name"].slice(6)
                  }}
                </h2>
              </div>
            </div>
            <div class="details__rank">
              <p
                class="details__rank--label"
                v-resize-text="{ ratio: 1, delay: 0, minFontSize: 8 }"
              >
                Rank
              </p>
              <div class="resize-text-wrapper">
                <h3 v-resize-text="{ ratio: 0.3, delay: 0 }">#{{ rank }}</h3>
              </div>
            </div>
            <div class="details__score">
              <div class="resize-text-wrapper">
                <h3 v-resize-text="{ ratio: 0.4, delay: 0 }">
                  {{ Math.round(nftData["calculated"]) }}
                </h3>
              </div>
            </div>
          </div>
          <div class="details__table">
            <table>
              <thead>
                <tr>
                  <th>Part</th>
                  <th>Code</th>
                  <th>Percentage</th>
                  <th>Total Pieces</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(part, index) in nftData['parts']" v-bind:key="index">
                  <td>{{ index }}</td>
                  <td>{{ nftData["parts"][index].code }}</td>
                  <td class="details__table--centered">
                    {{ parseFloat(nftData["parts"][index].percent) }}%
                  </td>
                  <td class="details__table--centered">
                    <span class="d-none d-md-block"
                      >({{ nftData["parts"][index].pcs }} / {{ noOfNft }})</span
                    >
                    <span class="d-md-none">({{ nftData["parts"][index].pcs }})</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-col>
      </b-row>
      <b-row v-else-if="found == 'no'">
        <h2>Not Found</h2>
      </b-row>
    </b-container>
    <b-container class="listing">
      <b-row>
        <b-col>
          <h1 class="listing__title kawaru text-md-center">Ranking</h1>
          <div class="listing__scroller d-md-none">
            <div
              class="listing__scroller--dots"
              v-scroll-to="{ el: '#listingRank', container: '#listingTable', x: true }"
              :class="{ 'listing__scroller--filled': isNftListColsVisible.rank }"
            />
            <div
              class="listing__scroller--dots"
              v-scroll-to="{ el: '#listingScore', container: '#listingTable', x: true }"
              :class="{ 'listing__scroller--filled': isNftListColsVisible.score }"
            />
          </div>
          <div class="listing__table" id="listingTable" @scroll="onScroll">
            <table>
              <thead>
                <tr>
                  <th id="listingRank" ref="listingRank">Rank</th>
                  <th>NFT</th>
                  <th>Name</th>
                  <th id="listingScore" ref="listingScore">Score</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(rank, index) in rankList"
                  v-bind:key="index"
                  @click="searchSnkrhd(rankList[index]['Revealed Name'])"
                >
                  <td class="rank">{{ index + 1 }}</td>
                  <td class="image">
                    <img
                      :src="
                        'https://ik.imagekit.io/jtuio7958s/ongaia/tr:w-200,h-200/' +
                          rankList[index]['Revealed Image']
                            .replace('fullsize', 'thumbnail')
                            .replace('.gif', '.webp')
                            .replace('.png', '.webp')
                      "
                      class="listingRankImg lazy"
                    />
                  </td>
                  <td class="name">{{ rankList[index]["Revealed Name"] }}</td>
                  <td class="score">
                    <div class="resize-text-wrapper">
                      <div v-resize-text="{ ratio: 0.8, delay: 0, maxFontSize: 24 }">
                        {{ Math.round(rankList[index]["calculated"]) }}
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="d-flex justify-content-center">
          <b-button block class="listing__load" @click="loadRanking(true)">Load More</b-button>
        </b-col>
      </b-row>
    </b-container>
  </main>
</template>
<script>
import ResizeText from "vue-resize-text";
import json from "../db/blox.json";

export default {
  name: "BloxSearch",
  directives: {
    ResizeText
  },
  data() {
    return {
      isFlowscore: true,
      snkrhd: "",
      snkrhdnftName: "",
      nftData: [],
      parts: [],
      found: "notyet",
      rank: "",
      top: 100,
      rankList: [],
      main_nft: null,
      noOfNft: json.blox.length,
      isNftListColsVisible: {
        rank: true,
        score: false
      }
    };
  },
  created() {
    try {
      // const res = await axios.get(baseURL);
      // this.snkrhd = res.data;
      this.loadRanking(false);
    } catch (e) {
      console.error(e);
    }
  },
  methods: {
    searchSnkrhd(id) {
      window.scrollTo(0, 0);

      this.snkrhdnftName = id;
      this.nftData = [];
      // this.parts = [];
      this.rank = "";
      this.main_nft = null;
      this.found = "notyet";

      try {
        const data = json.blox;

        for (let i = 0; i < data.length; i++) {
          if (
            data[i]["Revealed Name"].toLowerCase() == id.toLowerCase() ||
            data[i]["Revealed Name"] == `Bl0x1-${id}` ||
            data[i]["Revealed Name"] == `Bl0x1-0${id}` ||
            data[i]["Revealed Name"] == `Bl0x1-00${id}` ||
            data[i]["Revealed Name"] == `Bl0x1-000${id}`
          ) {
            this.found = "yes";
            this.rank = i + 1;
            this.nftData = data[i];
            this.main_nft = `https://ik.imagekit.io/jtuio7958s/ongaia/tr:w-1000,h-1000/${this.nftData["Revealed Image"]}`;
            this.nftData["Total Score"] = Math.round(this.nftData["Total Score"]);
            // this.parts = this.getRarity(this.nftData);
            // console.log(this.parts)
          }
        }
      } catch (e) {
        console.error(e);
      }

      if (this.found == "notyet" && id != "") {
        this.found = "no";
      }
    },
    loadRanking(loadMore) {
      const data = json.blox;
      if (loadMore) {
        this.top += 100;
      }
      this.rankList = data.slice(0, this.top);
    },
    checkNftListColVisible() {
      const listingRank = this.$refs.listingRank.getBoundingClientRect();
      const listingScore = this.$refs.listingScore.getBoundingClientRect();

      if (
        listingRank.top >= 0 &&
        listingRank.left >= 0 &&
        listingRank.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        listingRank.right <= (window.innerWidth || document.documentElement.clientWidth)
      ) {
        this.isNftListColsVisible.rank = true;
        this.isNftListColsVisible.score = false;
      }
      if (
        listingScore.top >= 0 &&
        listingScore.left >= 0 &&
        listingScore.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        listingScore.right <= (window.innerWidth || document.documentElement.clientWidth)
      ) {
        this.isNftListColsVisible.score = true;
        this.isNftListColsVisible.rank = false;
      }
    },
    onScroll() {
      this.checkNftListColVisible();
    }
  }
  /* mounted() {
    console.log(this.$refs.listingRank);
  } */
};
</script>
<style lang="scss">
@import "../styles/views/sidekicksearch.scss";
</style>
